import { MsdkStyledComponent, styled, uiTokens } from '@msdk/ui'
import type React from 'react'

type ReadonlyFieldContainerProps = React.ComponentProps<'div'>

export const ReadonlyFieldContainer: MsdkStyledComponent<ReadonlyFieldContainerProps> = styled(
  'div',
)<ReadonlyFieldContainerProps>`
  padding-right: ${uiTokens.spacing.padding.large}px;
`
